export default JSON.parse(JSON.stringify(window.Config));



// WEBPACK FOOTER //
// ./src/config.js